import React from "react";
import CarFooter from "../components/CarFooter";
import CarFooterbar from "../components/CarFooterbar";
import "../styles/variables.css";
import "../styles/TextStyle.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Section1 from "../sections/Section1";
import Section2 from "../sections/Section2";
import Section3 from "../sections/Section3";
import Section4 from "../sections/Section4";
import Section5 from "../sections/Section5";
import Section6 from "../sections/Section6";

const Home = () => {
  // Endpoint API per la home page
  const apiEndpointHome = `https://gestione.carellidistribuzione.it/react-endpoint-api/get-data-page/home-page?${new Date().getTime()}`;
  const [sectionsData, setSectionsData] = useState([]);

  const [showLoader, setShowLoader] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        // Esegui la chiamata all'API per ottenere i dati della home page
        const [resHome] = await Promise.all([axios.get(apiEndpointHome)]);
        console.log(resHome);
        
        const rdHome = resHome.data;
        const newSectionsData = [
          {
            section: 1,
            breadCrumbs:
              rdHome.data?.["home-page"]?.["303"]?.contenuti?.["332"]
                ?.breadcrumbs,
            contenuti: [332].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["303"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                immagineBg: contenuto?.immagine_url,
                callToAction: contenuto?.call_to_action_it,
                link: contenuto?.link_it,
              };
            }),
          },
          {
            section: 2,
            contenuti: [333].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["305"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                sottotitolo: contenuto?.sottotitolo_it,
                descrizione: contenuto?.descrizione_it,
                immaginiAggiuntive: contenuto?.immagini_aggiuntive?.map(
                  (img) => img.immagine_path
                ),
              };
            }),
          },
          {
            section: 3,
            contenuti: [334].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["307"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                immagineBg: contenuto?.immagine_url,
              };
            }),
            cards: [335, 336, 337, 338].map((id) => {
              const card = rdHome.data?.["home-page"]?.["307"]?.contenuti?.[id];
              return {
                immagine: card?.immagine_url,
                titolo: card?.titolo_it,
                descrizione: card?.descrizione_it,
                callToAction: card?.call_to_action_it,
                link: card?.link_it,
              };
            }),
          },

          {
            section: 4,
            contenuti: [339].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["308"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                sottotitolo: contenuto?.sottotitolo_it,
                descrizione: contenuto?.descrizione_it,
                immaginiAggiuntive: contenuto?.immagini_aggiuntive,
                callToAction: contenuto?.call_to_action_it,
                link: contenuto?.link_it,
              };
            }),
          },
          {
            section: 5,
            contenuti: [340].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["309"]?.contenuti?.[id];
              return {
                sottotitolo: contenuto?.sottotitolo_it,
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                link: contenuto?.link_it,
              };
            }),
            cards: [341, 342, 343, 346, 347, 348].map((id) => {
              const card = rdHome.data?.["home-page"]?.["309"]?.contenuti?.[id];
              return {
                immagineCard: card?.immagine_hover_1,
                immagineCardHover: card?.immagine_hover_2,
                titolo: card?.titolo_it,
                immagine: card?.immagine_url,
                link: card?.link_it
              };
            }),
          },

          {
            section: 6,
            contenuti: rdHome.data?.["home-page"]?.["311"]?.contenuti
          
          },
         
        {
          section: 99
        }
        ];

      
        setSectionsData(newSectionsData);
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);
      }
    };

    fetchData();
  }, []);


    useEffect(() => {
          if (sectionsData.length > 0) {
            setFadeOut(true);
            const timer = setTimeout(() => {
              setShowLoader(false);
              const footerElem = document.querySelector("footer");
              if (footerElem) {
                footerElem.classList.remove("d-none");
              }
            }, 500); 
            return () => clearTimeout(timer);
          }else{
            const f = document.querySelector('footer');
          if (f) f.classList.add('d-none');
          }
        }, [sectionsData]);
  



  return (
    <>
      {showLoader && (
        <div className={`layout-loader${fadeOut ? " fade-out" : ""}`}>
          <span className="loader" />
        </div>
      )}
      {sectionsData.map((section, index) => {
        switch (section.section) {
          case 1:
            return (
              <Section1
                key={index}
                contenuti={section.contenuti}
                breadCrumbs={section.breadCrumbs}
              />
            );
          case 2:
            return <Section2 key={index} contenuti={section.contenuti} />;
          case 3:
            return (
              <Section3
                key={index}
                contenuti={section.contenuti}
                cards={section.cards}
              />
            );
          case 4:
            return <Section4 key={index} contenuti={section.contenuti} />;
          case 5:
            return (
              <Section5
                key={index}
                contenuti={section.contenuti}
                cards={section.cards}
              />
            );
          case 6:
            return (
              <Section6
                key={index}
                contenuti={section.contenuti}
              />
            );
            default:
              return null;
        }
      })}
    </>
  );
};

export default Home;
